<template>
  <i v-if="isCustomerIcon" :class="['iconfont',getCustomerIconType]" :style="customerIconStyle"></i>
  <Icon v-else :type="type" :color="color" :size="size"></Icon>
</template>

<script>
  export default {
    name: "common-icon",
    props:{
      type:{
        type:String,
        default: ''
      },
      size:{
        type:Number,
        default: 10
      },
      color:{
        type:String,
        default: ''
      }
    },
    computed:{
      //是否是自定义Icon
      isCustomerIcon(){
        return this.type.indexOf('_') === 0
      },
      //自定义icon的样式
      customerIconStyle(){
        return  {
          fontSize:`${this.size}px`,
          color:this.color
        }
      },
      getCustomerIconType(){
        return this.type.indexOf('_') === 0 ? this.type.substring(1) : this.type
      }
    }
  }
</script>

<style scoped>

</style>